import React from 'react'
import banner from "../../../images/students/why.webp"
import { LuCircleCheckBig, LuFlame, LuRocket, LuTarget } from 'react-icons/lu'

export default function Why() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <img src={banner} alt='banner' loading='lazy' className='mx-auto object-cover w-[180px] md:w-auto' />
            <div className='mt-[14px] md:mt-[25px]'>
                <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Why Surge Students Exists</h3>
                <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Our mission is to foster a community where students can explore their passions, develop <br className='hidden xl:block' /> critical skills, and connect with mentors who inspire them. </p>
            </div>
            <div className='md:w-11/12 xl:w-10/12 mx-auto mt-[20px] md:mt-[54px] grid md:grid-cols-2 gap-[20px] md:gap-[50px]'>
                <div className='border border-[#B9F8CF] bg-gradient-to-r from-[#F0FDF4] to-[#ECFDF5] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <div className='bg-[#34C75921] rounded-full mx-auto w-max px-[8px] md:px-[16px] py-[4px] md:py-[8px] text-[#0D542B] text-[10px] md:text-[14px] font-bold flex gap-[5px] items-center'>
                        <LuRocket className='text-[#34C759]'/>
                        <p>WHAT WE HELP YOU DO</p>
                    </div>
                    <p className='text-[#0D542B] font-bold text-[20px] md:text-[27px] mt-[12px] md:mt-[25px]'>Elevate your potential.</p>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Develop future ready skills</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Master fundamentals that matter</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Elevate your potential and grow</p>
                        </div>
                    </div>
                </div>
                <div className='border border-[#FFC9C9] bg-[#FEF2F2] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <div className='bg-[#FFE2E2] rounded-full mx-auto w-max px-[8px] md:px-[16px] py-[4px] md:py-[8px] text-[#82181A] text-[10px] md:text-[14px] font-bold flex gap-[5px] items-center'>
                        <LuFlame className='text-[#E7000B]'/>
                        <p>WHY SURGE EXISTS</p>
                    </div>
                    <p className='text-[#82181A] font-bold text-[20px] md:text-[27px] mt-[12px] md:mt-[25px]'>From confusion to clarity.</p>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuTarget className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Surge helps students move from confusion to clarity</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuTarget className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Built from 10+ years of hiring and work experience</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuTarget className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>We partner with colleges to make students industry-ready</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-[20px] md:mt-[54px]'>
                <h4 className='text-[#101828] font-semibold text-[24px] md:text-[54px]'>India doesn’t lack talent.</h4>
                <h4 className='text-[#32ADE6] font-medium text-[14px] md:text-[38px] mt-[6px] md:mt-[12px]'>India lacks alignment, clarity & real-world readiness.</h4>
            </div>
            <div className='mt-[20px] md:mt-[32px] bg-[#007AFF1A] w-full md:w-9/12 mx-auto rounded-[12px] md:rounded-[20px] p-[15px] md:p-[24px] text-[#007AFF] text-center font-medium text-[16px] md:text-[24px]'>
                <p>So we built a new system, a bridge between theory & capability, confusion & clarity, potential & performance. </p>
            </div>
        </div>
    )
}
